/** Post Cloud Onboarding data */
export const POST_CLOUD_ONBOARDING = "POST_CLOUD_ONBOARDING";
export const POST_CLOUD_ONBOARDING_FAIL = "POST_CLOUD_ONBOARDING_FAIL";
export const POST_GCP_ONBOARDING = "POST_GCP_ONBOARDING";
export const POST_GCP_ONBOARDING_FAIL = "POST_GCP_ONBOARDING_FAIL";
export const POST_AZURE_ONBOARDING = "POST_AZURE_ONBOARDING";
export const POST_AZURE_ONBOARDING_FAIL = "POST_AZURE_ONBOARDING_FAIL";
export const POST_SERVICE_ONBOARDING = "POST_SERVICE_ONBOARDING";
export const POST_SERVICE_ONBOARDING_FAIL = "POST_SERVICE_ONBOARDING_FAIL";
export const POST_NEW_RELIC_ONBOARDING = "POST_NEW_RELIC_ONBOARDING";
export const POST_NEW_RELIC_ONBOARDING_FAIL = "POST_NEW_RELIC_ONBOARDING_FAIL";
export const POST_INITIAL_ONBOARDING = "POST_INITIAL_ONBOARDING";
export const POST_INITIAL_ONBOARDING_FAIL = "POST_INITIAL_ONBOARDING_FAIL";
export const POST_OPSGENIE_ONBOARDING = "POST_OPSGENIE_ONBOARDING";
export const POST_OPSGENIE_ONBOARDING_FAIL = "POST_OPSGENIE_ONBOARDING_FAIL";
export const POST_PAGERDUTY_ONBOARDING = "POST_PAGERDUTY_ONBOARDING";
export const POST_PAGERDUTY_ONBOARDING_FAIL = "POST_PAGERDUTY_ONBOARDING_FAIL";
export const POST_PAGERDUTY_ONBOARDING_SUCCESS = "POST_PAGERDUTY_ONBOARDING_SUCCESS";
export const POST_APPLICATION_SERVICE_ONBOARDING = "POST_APPLICATION_SERVICE_ONBOARDING";
export const POST_APPLICATION_SERVICE_ONBOARDING_SUCCESS = "POST_APPLICATION_SERVICE_ONBOARDING_SUCCESS";
export const POST_APPLICATION_SERVICE_ONBOARDING_FAIL = "POST_APPLICATION_SERVICE_ONBOARDING_FAIL";
export const POST_ONBOARD_ALERT = "POST_ONBOARD_ALERT";
export const POST_ONBOARD_ALERT_FAIL = "POST_ONBOARD_ALERT_FAIL";
export const POST_RESOURCE_DISABLE_ALERTS = "POST_RESOURCE_DISABLE_ALERTS";
export const POST_RESOURCE_DISABLE_ALERTS_FAIL = "POST_RESOURCE_DISABLE_ALERTS_FAIL";
export const POST_UPDATE_ALERS = "POST_UPDATE_ALERS";
export const POST_UPDATE_ALERS_FAIL = "POST_UPDATE_ALERS_FAIL";
export const PUT_THRESHOLD = "PUT_THRESHOLD";
export const PUT_THRESHOLD_FAIL = "PUT_THRESHOLD_FAIL";
export const POST_CREATE_RESOURCE_ALERTS = "POST_CREATE_RESOURCE_ALERTS";
export const POST_CREATE_RESOURCE_ALERTS_FAIL = "POST_CREATE_RESOURCE_ALERTS_FAIL";

//New Relic Actions
export const POST_NEW_RELIC_RESOURCE_DISABLE_ALERTS = "POST_NEW_RELIC_RESOURCE_DISABLE_ALERTS";
export const POST_NEW_RELIC_RESOURCE_DISABLE_ALERTS_FAIL = "POST_NEW_RELIC_RESOURCE_DISABLE_ALERTS_FAIL";
export const POST_NEW_RELIC_UPDATE_ALERS = "POST_NEW_RELIC_UPDATE_ALERS";
export const POST_NEW_RELIC_UPDATE_ALERS_FAIL = "POST_NEW_RELIC_UPDATE_ALERS_FAIL";
export const PUT_NEW_RELIC_ALERTS = "PUT_NEW_RELIC_ALERTS";
export const PUT_NEW_RELIC_ALERTS_FAIL = "PUT_NEW_RELIC_ALERTS_FAIL";
export const PUT_NEW_RELIC_THRESHOLD = "PUT_NEW_RELIC_THRESHOLD";
export const PUT_NEW_RELIC_THRESHOLD_FAIL = "PUT_NEW_RELIC_THRESHOLD_FAIL";
export const POST_NEW_RELIC_CREATE_RESOURCE_ALERTS = "POST_NEW_RELIC_CREATE_RESOURCE_ALERTS";
export const POST_NEW_RELIC_CREATE_RESOURCE_ALERTS_FAIL = "POST_NEW_RELIC_CREATE_RESOURCE_ALERTS_FAIL";

export const POST_MAP_RESOURCE_TO_EMAIL = "POST_MAP_RESOURCE_TO_EMAIL";
export const POST_MAP_RESOURCE_TO_EMAIL_FAIL = "POST_MAP_RESOURCE_TO_EMAIL_FAIL";

export const POST_APP_DYNAMICS_ONBOARDING = "POST_APP_DYNAMICS_ONBOARDING";
export const POST_APP_DYNAMICS_ONBOARDING_FAIL = "POST_APP_DYNAMICS_ONBOARDING_FAIL";
export const POST_APP_DYNAMICS_ONBOARDING_SUCCESS = "POST_APP_DYNAMICS_ONBOARDING_SUCCESS";

export const POST_NEWRELIC_DISABLE_THRESHOLD_ALERTS = "POST_NEWRELIC_DISABLE_THRESHOLD_ALERTS";
export const POST_NEWRELIC_DISABLE_THRESHOLD_ALERTS_FAIL = "POST_NEWRELIC_DISABLE_THRESHOLD_ALERTS_FAIL";
export const POST_NEWRELIC_ENABLE_THRESHOLD_ALERTS = "POST_NEWRELIC_ENABLE_THRESHOLD_ALERTS";
export const POST_NEWRELIC_ENABLE_THRESHOLD_ALERTS_FAIL = "POST_NEWRELIC_ENABLE_THRESHOLD_ALERTS_FAIL";

export const POST_DATADOG_ONBOARDING = "POST_DATADOG_ONBOARDING";
export const POST_DATADOG_ONBOARDING_FAIL = "POST_DATADOG_ONBOARDING_FAIL";
export const POST_DATADOG_ONBOARDING_SUCCESS = "POST_DATADOG_ONBOARDING_SUCCESS";

export const POST_SPLUNK_ONBOARDING = "POST_SPLUNK_ONBOARDING";
export const POST_SPLUNK_ONBOARDING_FAIL = "POST_SPLUNK_ONBOARDING_FAIL";
export const POST_SPLUNK_ONBOARDING_SUCCESS = "POST_SPLUNK_ONBOARDING_SUCCESS";

export const TEST_AZURE_CONNECTION = "TEST_AZURE_CONNECTION";
export const TEST_AZURE_CONNECTION_FAIL = "TEST_AZURE_CONNECTION_FAIL";
export const TEST_AZURE_CONNECTION_SUCCESS = "TEST_AZURE_CONNECTION_SUCCESS";

export const TEST_SIGNOZ_CONNECTION = "TEST_SIGNOZ_CONNECTION";
export const TEST_SIGNOZ_CONNECTION_FAIL = "TEST_SIGNOZ_CONNECTION_FAIL";
export const TEST_SIGNOZ_CONNECTION_SUCCESS = "TEST_SIGNOZ_CONNECTION_SUCCESS";

export const TEST_GCP_CONNECTION = "TEST_GCP_CONNECTION";
export const TEST_GCP_CONNECTION_FAIL = "TEST_GCP_CONNECTION_FAIL";
export const TEST_GCP_CONNECTION_SUCCESS = "TEST_GCP_CONNECTION_SUCCESS";

export const TEST_AWS_CONNECTION = "TEST_AWS_CONNECTION";
export const TEST_AWS_CONNECTION_FAIL = "TEST_AWS_CONNECTION_FAIL";
export const TEST_AWS_CONNECTION_SUCCESS = "TEST_AWS_CONNECTION_SUCCESS";

export const POST_DYNATRACE_ONBOARDING = "POST_DYNATRACE_ONBOARDING";
export const POST_DYNATRACE_ONBOARDING_FAIL = "POST_DYNATRACE_ONBOARDING_FAIL";
export const POST_DYNATRACE_ONBOARDING_SUCCESS = "POST_DYNATRACE_ONBOARDING_SUCCESS";

export const GET_ALL_AWS_ACCOUNTS = "GET_ALL_AWS_ACCOUNTS";
export const GET_ALL_AWS_ACCOUNTS_FAIL = "GET_ALL_AWS_ACCOUNTS_FAIL";
export const GET_ALL_AWS_ACCOUNTS_SUCCESS = "GET_ALL_AWS_ACCOUNTS_SUCCESS";

export const DELETE_AWS_ACCOUNT = "DELETE_AWS_ACCOUNT";
export const DELETE_AWS_ACCOUNT_FAIL = "DELETE_AWS_ACCOUNT_FAIL";
export const DELETE_AWS_ACCOUNT_SUCCESS = "DELETE_AWS_ACCOUNT_SUCCESS";

export const GET_ENCRYPTED_ORG_ID = "GET_ENCRYPTED_ORG_ID";
export const GET_ENCRYPTED_ORG_ID_FAIL = "GET_ENCRYPTED_ORG_ID_FAIL";
export const GET_ENCRYPTED_ORG_ID_SUCCESS = "GET_ENCRYPTED_ORG_ID_SUCCESS";

export const POST_OCI_ONBOARDING = "POST_OCI_ONBOARDING";
export const POST_OCI_ONBOARDING_FAIL = "POST_OCI_ONBOARDING_FAIL";

export const TEST_OCI_CONNECTION = "TEST_OCI_CONNECTION";
export const TEST_OCI_CONNECTION_SUCCESS = "TEST_OCI_CONNECTION_SUCCESS";
export const TEST_OCI_CONNECTION_FAIL = "TEST_OCI_CONNECTION_FAIL";

export const TEST_SENTRY_CONNECTION = "TEST_SENTRY_CONNECTION";
export const TEST_SENTRY_CONNECTION_SUCCESS = "TEST_SENTRY_CONNECTION_SUCCESS";
export const TEST_SENTRY_CONNECTION_FAIL = "TEST_SENTRY_CONNECTION_FAIL";

export const POST_SENTRY_ONBOARDING = "POST_SENTRY_ONBOARDING";
export const POST_SENTRY_ONBOARDING_FAIL = "POST_SENTRY_ONBOARDING_FAIL";

export const RESET_SENTRY_STATES = "RESET_SENTRY_STATES";

export const TEST_LOKI_CONNECTION = "TEST_LOKI_CONNECTION";
export const TEST_LOKI_CONNECTION_SUCCESS = "TEST_LOKI_CONNECTION_SUCCESS";
export const TEST_LOKI_CONNECTION_FAIL = "TEST_LOKI_CONNECTION_FAIL";

export const POST_LOKI_ONBOARDING = "POST_LOKI_ONBOARDING";
export const POST_LOKI_ONBOARDING_FAIL = "POST_LOKI_ONBOARDING_FAIL";

export const RESET_LOKI_STATES = "RESET_LOKI_STATES";

export const TEST_CORALOGIX_CONNECTION = "TEST_CORALOGIX_CONNECTION";
export const TEST_CORALOGIX_CONNECTION_SUCCESS = "TEST_CORALOGIX_CONNECTION_SUCCESS";
export const TEST_CORALOGIX_CONNECTION_FAIL = "TEST_CORALOGIX_CONNECTION_FAIL";

export const POST_CORALOGIX_ONBOARDING = "POST_CORALOGIX_ONBOARDING";
export const POST_CORALOGIX_ONBOARDING_FAIL = "POST_CORALOGIX_ONBOARDING_FAIL";

export const RESET_CORALOGIX_STATES = "RESET_CORALOGIX_STATES";


export const GET_ALL_AZURE_ACCOUNTS = "GET_ALL_AZURE_ACCOUNTS";
export const GET_ALL_AZURE_ACCOUNTS_FAIL = "GET_ALL_AZURE_ACCOUNTS_FAIL";
export const GET_ALL_AZURE_ACCOUNTS_SUCCESS = "GET_ALL_AZURE_ACCOUNTS_SUCCESS";

export const POST_GRAFANA_ONBOARDING = "POST_GRAFANA_ONBOARDING"
export const POST_GRAFANA_ONBOARDING_FAIL = "POST_GRAFANA_ONBOARDING_FAIL";

export const POST_SIGNOZ_ONBOARDING = "POST_SIGNOZ_ONBOARDING"
export const POST_SIGNOZ_ONBOARDING_FAIL = "POST_SIGNOZ_ONBOARDING_FAIL";

export const GET_ALL_GCP_PROJECTS = "GET_ALL_GCP_PROJECTS";
export const GET_ALL_GCP_PROJECTS_SUCCESS = "GET_ALL_GCP_PROJECTS_SUCCESS";
export const GET_ALL_GCP_PROJECTS_FAIL = "GET_ALL_GCP_PROJECTS_FAIL";

export const GET_ALL_NEW_RELIC_ACCOUNTS = "GET_ALL_NEW_RELIC_ACCOUNTS";
export const GET_ALL_NEW_RELIC_ACCOUNTS_FAIL = "GET_ALL_NEW_RELIC_ACCOUNTS_FAIL";
export const GET_ALL_NEW_RELIC_ACCOUNTS_SUCCESS = "GET_ALL_NEW_RELIC_ACCOUNTS_SUCCESS";

export const DELETE_NEW_RELIC_ACCOUNT = "DELETE_NEW_RELIC_ACCOUNT";
export const DELETE_NEW_RELIC_ACCOUNT_FAIL = "DELETE_NEW_RELIC_ACCOUNT_FAIL";
export const DELETE_NEW_RELIC_ACCOUNT_SUCCESS = "DELETE_NEW_RELIC_ACCOUNT_SUCCESS";

